import { decrypt } from "./others";
// Imported from the vendor-free internals rather than the ../featureFlags barrel: the barrel
// pulls in the Statsig provider and React, which a plain util module has no business dragging
// along. activeFlags/registry carry no vendor import, so the eslint fence is respected either way.
import { FeatureFlag } from "../featureFlags/activeFlags";
import { FLAGS } from "../featureFlags/registry";

export const auth = () => !!decrypt(localStorage.user);

export const getRole = () => {
  const role = decrypt(localStorage.user);
  return role.role;
};

// Mentor LMS req 5/7 — shared check for "mentor" or "temp_mentor", replacing
// the same string comparison copy-pasted across App.jsx,
// UnwatchedCountContext.jsx, and SideNavigationBar.jsx.
export const isMentorLikeRole = (role) => role === "mentor" || role === "temp_mentor";

// SPRIN-3237 — a cs_person the merge has NOT yet freed from the hardcoded edit guards.
//
// IMPERATIVE, and deliberately kept that way for EVENT HANDLERS only — pauseOrder and
// removeStudentFromBatch in Classes/Home. Those run after a click, long after the flag has
// resolved, so they do not need to re-render on anything.
//
// Anything on the RENDER path must use useIsRestrictedCsm / useIsModeratorLikeRole / useHasPermission
// from utils/usePermission instead. This function reads the imperative FeatureFlag singleton, which
// the provider swaps in via registerChecker — a module-variable mutation that re-renders nothing, so
// a component calling this during render would paint the flag-OFF version and never correct itself.
export const isRestrictedCsm = () =>
  getRole() === "cs_person"
  && !FeatureFlag.isFeatureActive(FLAGS.EPICENTER_MODERATOR_CSM_MERGE.name);

export const getPermission = () =>{
  const permission = decrypt(localStorage.user)
  return permission.permissions
}

export const getUserId = () => {
  const user = decrypt(localStorage.user);
  return user.user_id;
};
